// extracted by mini-css-extract-plugin
module.exports = {"desktop":"DentalBanner_desktop__XvS6P","mobile":"DentalBanner_mobile__IwrEL"};